import { call, put, takeLatest } from "redux-saga/effects";
import { dashboardAPI } from "../api/api";
import { actionTypes } from "../store/reducers/dashboardReducer";

function* getDashboardStats(): Generator<any, void, any> {
  try {
    const response: any = yield call(dashboardAPI.getDashboardStats);
    if (response.status === 200) {
      yield put({
        type: actionTypes.GET_DASHBOARD_STATS_SUCCESS,
        payload: response.data.data,
      });
    }
  } catch (error: any) {
    yield put({
      type: actionTypes.GET_DASHBOARD_STATS_ERROR,
      payload:
        error.response?.data?.message || "Failed to load dashboard",
    });
  }
}

export function* dashboardWatcher() {
  yield takeLatest(actionTypes.GET_DASHBOARD_STATS, getDashboardStats);
}
